import axios from "axios";
import config from "../utils/config";
import { Auth } from "aws-amplify";

export const getCalendlyEvents = async (startTime, endTime, email) => {
  const baseURL = config.API_URL;
  const path = `/ops_monitoring/get_calendly_events_by_date?startTime=${startTime}&endTime=${endTime}&email=${email}`;
  const res = await axios.get(baseURL + path);
  return res.data;
};

export const getCalendlyMeInfo = (access_token) => {
  const baseURL = "https://api.calendly.com";
  const path = "/users/me";
  return axios.get(baseURL + path, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};

export const getOrganizationRegisteredWebhookUrls = async (
  accessToken,
  organization
) => {
  const baseURL = "https://api.calendly.com";
  const path = `/webhook_subscriptions?organization=${organization}&scope=organization`;

  const res = await axios.get(baseURL + path, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return res.data;
};

export const getUserRegisteredWebhookUrls = async (
  accessToken,
  organization,
  user
) => {
  const baseURL = "https://api.calendly.com";
  const path = `/webhook_subscriptions?organization=${organization}&scope=user&user=${user}`;

  const res = await axios.get(baseURL + path, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return res.data;
};

export const getCalendlyTherawinData = async (therapist_id) => {
  const baseURL = config.API_URL;
  const path = "/calendly/get_calendly_data_by_therapist_id";
  const params = "?therapist_id=" + therapist_id;
  const idToken = (await Auth.currentSession()).getIdToken().getJwtToken();
  return axios.get(baseURL + path + params, {
    headers: {
      Authorization: idToken,
    },
  });
};

export const registerCalendlyWebhookSubscription = async (
  accessToken,
  url,
  organization,
  user,
  scope
) => {
  const baseURL = "https://api.calendly.com";
  const path = `/webhook_subscriptions`;
  const events = ["invitee.created"];

  const res = await axios.post(
    baseURL + path,
    {
      url,
      events,
      organization,
      user,
      scope,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return res.data;
};

export const getCalendlyAuthUrl = async () => {
  // const baseURL = "http://localhost:4000";
  const baseURL = config.API_URL;
  const path = "/calendly/calendly_oauth";
  console.log("baseURL", baseURL + path);

  const idToken = (await Auth.currentSession()).getIdToken().getJwtToken();
  const res = await axios.get(baseURL + path, {
    headers: {
      Authorization: idToken,
    },
  });
  console.log(res);
  return res;
};

export const postCalendlyTherawinMap = async (
  therapist_id,
  calendly_user_id,
  calendly_email,
  access_token,
  refresh_token,
  expires_in,
  webhook_is_registered
) => {
  const baseURL = config.API_URL;
  const path = "/calendly/calendly_therawin_map";

  const idToken = (await Auth.currentSession()).getIdToken().getJwtToken();
  const res = await axios.post(
    baseURL + path,
    {
      therapist_id,
      calendly_user_id,
      calendly_email,
      access_token,
      refresh_token,
      expires_in,
      webhook_is_registered,
    },
    {
      headers: {
        Authorization: idToken,
      },
    }
  );

  return res;
};

export const calendlyAuthCallback = async (therapist_id, code) => {
  // const baseURL = "http://localhost:4000";
  const baseURL = config.API_URL;
  const path = "/calendly/calendly_oauth_callback";

  const idToken = (await Auth.currentSession()).getIdToken().getJwtToken();
  const res = await axios.post(
    baseURL + path,
    {
      therapist_id,
      code,
    },
    {
      headers: {
        Authorization: idToken,
      },
    }
  );
  return res;
};

export const getSimplePracticeEvents = async (startTime, endTime, email) => {
  const baseURL = config.API_URL;
  const path = `/ops_monitoring/get_simple_practice_events?startTime=${startTime}&endTime=${endTime}&email=${email}`;
  const res = await axios.get(baseURL + path);
  return res.data;
};

export const getMissedEvents = async (therapistId) => {
  const baseURL = config.API_URL;
  const path = `/get-missed-dispositions?therapist_id=${therapistId}`;
  const res = await axios.get(baseURL + path);
  return res.data;
};
